var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import './BuildVersionStatus.scss';
var BuildVersionStatus = /** @class */ (function (_super) {
    __extends(BuildVersionStatus, _super);
    function BuildVersionStatus(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { buildVersion: "20261019.1" };
        return _this;
    }
    BuildVersionStatus.prototype.componentDidMount = function () {
    };
    BuildVersionStatus.prototype.render = function () {
        if (this.state.buildVersion == "") {
            return (React.createElement("div", null));
        }
        else {
            return (React.createElement("div", { className: 'buildVersion h3' },
                React.createElement("p", null, this.state.buildVersion)));
        }
    };
    return BuildVersionStatus;
}(React.Component));
export default BuildVersionStatus;
;
